import drawingClasses from "./drawing.class";

export default function registerModelClasses(module) {
    module.value("GeneratedDrawing", drawingClasses.GeneratedDrawing);
    module.value("DrawingConfiguration", drawingClasses.DrawingConfiguration);
    module.value("UploadedDrawing", drawingClasses.UploadedDrawing);
}
